import {
    browserName,
    browserVersion,
    isMobile,
    osName
} from 'react-device-detect';
import { apiClientInstance } from './axiosClient';

export const metricsApi = {
    counterMetric: async (name, labels, help) => {
        try {
            // eslint-disable-next-line no-console
            console.log(name, labels, help);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err.stack);
        }
    },
    errorMetric: async (description, statusCode, error) => {
        try {
            await apiClientInstance.post('/client/metric/error', {
                description,
                payload: {
                    error,
                    metadata: {
                        statusCode,
                        browserName,
                        browserVersionNo: browserVersion,
                        isMobile,
                        os: osName,
                        sizeScreenH: window.innerHeight,
                        sizeScreenW: window.innerWidth
                    }
                }
            });
        } catch (err) {
            // eslint no-empty: "error"
        }
    }
};

export default metricsApi;
